import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const DLCourseDetails2 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>

        <ol>
          <li>
            理解深度學習的核心理論與運作機制，掌握神經網路如何學習資料中的特徵與模式。
          </li>
          <li>
            熟悉人工神經網路、卷積神經網路、循環神經網路、Transformer、GAN、VAE、Diffusion
            等主流深度學習架構及其應用場景。
          </li>
          <li>
            完成多個實作
            Lab，涵蓋影像分類、電腦視覺與序列資料分析等真實應用案例。
          </li>
          <li>
            掌握模型優化技巧，包括 Dropout、Batch Normalization、Learning Rate
            Scheduling 等重要方法。
          </li>
          <li>
            了解深度學習模型的訓練流程、模型調參策略與深度學習專案開發流程，提升實務能力。
          </li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>

        <ol>
          <li>已具備 Python 與機器學習基礎，想進一步學習深度學習的學習者</li>
          <li>對人工智慧、電腦視覺或自然語言處理有興趣的學生與工程師</li>
          <li>想建立深度學習實戰能力，提升研究、專題或職場競爭力的人員</li>
        </ol>
      </motion.div>

      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default DLCourseDetails2;
